import { render, staticRenderFns } from "./TicketBox.vue?vue&type=template&id=25f377f3&scoped=true"
import script from "./TicketBox.vue?vue&type=script&lang=js"
export * from "./TicketBox.vue?vue&type=script&lang=js"
import style0 from "./TicketBox.vue?vue&type=style&index=0&id=25f377f3&prod&lang=css"
import style1 from "./TicketBox.vue?vue&type=style&index=1&id=25f377f3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25f377f3",
  null
  
)

export default component.exports